// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhi_ji","CommentListPlaceholder--Legacy":"ih_b bhi_ra bhi_wo"};